@if (!(isInitialLoading$ | async)) {
  <article [ngClass]="{ 'full-screen': isFullScreen$ | async }">
    <header>
      <h2 class="modal-title pull-left mr-4">
        {{
          'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.EDIT-DEPARTURE' | translate
        }}
      </h2>

      <a
        class="filter-button azure pointer"
        type="button"
        (click)="toggleFullScreen()"
      >
        <span
          class="filter-button-icon fullscreen-btn"
          [inlineSVG]="
            '../assets/img/icons/fullscreen-' +
            ((isFullScreen$ | async) ? 'off' : 'on') +
            '.svg'
          "
        ></span>
        <span>
          {{
            ((isFullScreen$ | async) ? 'FULLSCREEN_OFF' : 'FULLSCREEN_TOOLTIP')
              | translate
          }}
        </span>
      </a>
    </header>

    <app-batch-mailing-form
      class="batch-mailing-form"
      [batch]="batch$ | async"
      [batchMailingData]="batchMailingData$ | async"
      [batchProperties]="batchProperties$ | async"
    />

    <footer class="footer">
      <button type="button" class="button button--outlined" (click)="back()">
        {{ 'BACK' | translate }}
      </button>

      <div class="footer-buttons-block">
        <button
          class="button button--filled button--shadow"
          type="button"
          [disabled]="isBatchMailingProcessing$ | async"
          (click)="submit()"
        >
          {{ 'SAVE' | translate }}
        </button>
      </div>
    </footer>
  </article>
} @else {
  <main class="text-secondary text-center">
    <div class="spinner-border spinner-border-lg" role="status">
      <span class="sr-only">{{ 'LOADING' | translate }}</span>
    </div>
  </main>
}
